import { fetchGetCardsListApi, fetchGetFavCardsApi, fetchAddFavCardsApi } from '../../api/LeftNavApi';
import { CONSTANTS } from '../../constants/Constants';
import { getCards, applicationPins } from '../../api/urls';
import TokenManager from '../../utils/TokenManager';
const {
  ACTIONS
} = CONSTANTS;
export const fetchCardsList = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(getCards);
  return fetchGetCardsListApi(url).then(data => {
    dispatch({
      type: ACTIONS.FETCH_GET_CARD_LIST_SUCCESS,
      payload: data
    });
  }).catch(error => {
    dispatch({
      type: ACTIONS.FETCH_GET_CARD_LIST_ERROR,
      payload: error
    });
  });
};
export const fetchFavCardsList = baseUrl => dispatch => {
  const url = "".concat(baseUrl).concat(applicationPins);
  return fetchGetFavCardsApi(url).then(data => {
    dispatch({
      type: ACTIONS.FETCH_GET_FAVCARD_LIST_SUCCESS,
      payload: data
    });
  }).catch(error => {
    dispatch({
      type: ACTIONS.FETCH_GET_FAVCARD_LIST_ERROR,
      payload: error
    });
  });
};
export const addFavoriteCards = (cards, baseUrl) => dispatch => {
  const url = "".concat(baseUrl).concat(applicationPins);
  return fetchAddFavCardsApi(url, {
    application_pins: cards,
    email: TokenManager.getItem('email')
  }).then(data => {
    dispatch({
      type: ACTIONS.FETCH_GET_FAVCARD_LIST_SUCCESS,
      payload: data
    });
  }).catch(error => {
    dispatch({
      type: ACTIONS.ADD_FAVCARD_LIST_ERROR,
      payload: error
    });
  });
};